import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { ModalController, IonSlides } from "@ionic/angular";
import { CoreProvider } from "src/app/providers/core/core.service";

@Component({
  selector: "app-fullscreen-modal",
  templateUrl: "./fullscreen-modal.page.html",
  styleUrls: ["./fullscreen-modal.page.scss"],
})
export class FullscreenModalPage implements OnInit {
  
  @Input() serviceCardImageBase64: any;
  isFront = true;
  @ViewChild(IonSlides, { static: false }) slides: IonSlides;
  slideOpts = {
    allowTouchMove: true,
    speed: 400,
  };
  eleFront: any;
  eleBack: any;
  slideIndex: number;
  serviceCardImageType: string;
  isFirstSLide = false;
  isLastSLide = false;
  cardshow: any;

  constructor(
    private modalCtrl: ModalController,
    private coreService: CoreProvider,
  ) {
    this.serviceCardImageType = coreService.serviceCardImageType;
  }
  slidePrev() {
    this.slides.slidePrev();
  }
  slideNext() {
    this.slides.slideNext();
  }

  ngOnInit() {}
  
  closeModal() {
    this.modalCtrl.dismiss();
  }
  onSlideLoad() {
    this.slides.slideTo(0);
    this.slides.getActiveIndex().then((index) => {
      this.slideIndex = index;
      this.isFirstSLide =  (index === 0);
    });
  }
  goNext() {
    this.slideIndex++;
    this.isLastSLide =
    this.slideIndex >= this.cardshow.length - 1 ? true : false;
    this.isFirstSLide = this.slideIndex === 0 ? true : false
    this.slides.slideNext();
  }
  goPrev() {
    this.slideIndex--;
    this.isFirstSLide = this.slideIndex === 0 ? true : false;
    this.isLastSLide =
      this.slideIndex >= this.cardshow.length - 1 ? true : false;
    this.slides.slidePrev();
  }
  slideChanged() {
    this.slides.getActiveIndex().then((index) => {
      this.slideIndex = index;
      if (index === 0) {
        this.isFirstSLide =  true;
        this.isLastSLide = false;
      } else {
        this.isFirstSLide =  false;
        this.isLastSLide = true;
      }
    });
  }
}
